import { render, staticRenderFns } from "./DocumentSharing.vue?vue&type=template&id=08eb9a24&"
import script from "./DocumentSharing.vue?vue&type=script&lang=js&"
export * from "./DocumentSharing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports